import { Type } from "@sinclair/typebox";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const startSessionRequestSchema = Type.Object({
    userId: Type.Optional(Type.String()),
    platform: Type.Union([
        Type.Literal("ios"),
        Type.Literal("android"),
        Type.Literal("web"),
        Type.Literal("web_account"),
        Type.Literal("watchos"),
        Type.Literal("web_freemium"),
    ]),
    referralId: Type.Optional(Type.String()),
    referralCode: Type.Optional(Type.String()),
    referrerUserId: Type.Optional(Type.String()),
    referralCTAId: Type.Optional(Type.String()),
    referralCampaign: Type.Optional(Type.String()),
    shareType: Type.Optional(Type.String()),
    utmMedium: Type.Optional(Type.String()),
    utmContent: Type.Optional(Type.String()),
    utmCampaign: Type.Optional(Type.String()),
    utmSource: Type.Optional(Type.String()),
    sourceId: Type.Optional(Type.String()),
    referrer: Type.Optional(Type.String()),
    testUser: Type.Optional(Type.Boolean()),
    isDebugger: Type.Optional(Type.Boolean()),
    brandUserId: Type.Optional(Type.String()),
    forceTest: Type.Optional(Type.Array(Type.String())),
    organizationId: Type.Optional(Type.String()),
    b2bBillingUserId: Type.Optional(Type.String()),
    timezone: Type.Optional(Type.String()),
    defaultTimezoneOffset: Type.Optional(Type.Number()),
    phoneNumber: Type.Optional(Type.String()),
    forceLeadClient: Type.Optional(Type.Boolean()),
});
export const startSessionResponseSchema = Type.Object({
    sessionId: Type.String(),
    userId: Type.String(),
    activeTests: Type.Array(Type.String()),
});
export const startSession = (startSessionRequest) => {
    return api
        .post("analytics/startSession", {
        json: startSessionRequest,
    })
        .json();
};
export const startSessionQueryOptions = (data) => {
    return queryOptions({
        queryKey: ["start_session", data],
        queryFn: () => startSession(data),
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        gcTime: 1000 * 60 * 60, // 1 hour
        staleTime: 1000 * 60 * 60, // 1 hour
    });
};
export const useStartSession = ({ queryConfig, startSessionData, }) => {
    return useQuery({
        ...startSessionQueryOptions(startSessionData),
        ...queryConfig,
    });
};
//# sourceMappingURL=startSession.js.map